// extracted by mini-css-extract-plugin
export default {"cls1":"o0IOKElhuZpvSdR_g8w4","cls2":"ilmY0h5IdGwDy4B5KFY6 o0IOKElhuZpvSdR_g8w4","isPhone":"HKRMIdhXGNzKZM2RpbFB"};